// removed by extract-text-webpack-plugin
module.exports = {"admin":"AdminPage_admin__23Dh","info":"AdminPage_info__34v1","side":"AdminPage_side__2dnd","SelectedChoice":"AdminPage_SelectedChoice__28oJ","SignOut":"AdminPage_SignOut__3px9","NavChoice":"AdminPage_NavChoice__2-VU","NavSubChoice":"AdminPage_NavSubChoice__19-A"};


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/Admin/AdminPage.scss
// module id = 681
// module chunks = 0